var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature3Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66797 1.66406C5.11568 1.66406 4.66797 2.11178 4.66797 2.66406V3.66406H3.66797C2.5634 3.66406 1.66797 4.55949 1.66797 5.66406V15.6641C1.66797 16.7686 2.5634 17.6641 3.66797 17.6641H15.668C16.7725 17.6641 17.668 16.7686 17.668 15.6641V5.66406C17.668 4.55949 16.7725 3.66406 15.668 3.66406H14.668V2.66406C14.668 2.11178 14.2203 1.66406 13.668 1.66406C13.1157 1.66406 12.668 2.11178 12.668 2.66406V3.66406H6.66797V2.66406C6.66797 2.11178 6.22025 1.66406 5.66797 1.66406ZM5.66797 6.66406C5.11568 6.66406 4.66797 7.11178 4.66797 7.66406C4.66797 8.21635 5.11568 8.66406 5.66797 8.66406H13.668C14.2203 8.66406 14.668 8.21635 14.668 7.66406C14.668 7.11178 14.2203 6.66406 13.668 6.66406H5.66797Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3Icon);
export default __webpack_public_path__ + "static/media/feature-3-icon.7cf5b6a0033a2721863abf69f0e6172b.svg";
export { ForwardRef as ReactComponent };